var carinaDefaultFormula = function(param) {
    var palette = param.default, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        flags: {}
    };
    var flags = options.flags;
    var typographyUpdates = flags.typographyUpdates;
    return {
        colors: {
            neutral: palette.neutral,
            brand: palette.brand,
            interactive: palette.interactive,
            accent: palette.accent,
            tertiary: palette.tertiary,
            danger: palette.danger,
            warning: palette.warning,
            success: palette.success,
            accessory: {
                1: palette.accessoryOne,
                2: palette.accessoryTwo,
                3: palette.accessoryThree,
                4: palette.accessoryFour,
                5: palette.accessoryFive
            }
        },
        backgroundColor: {
            base: palette.neutral.zero,
            active: palette.neutral[15],
            focus: palette.neutral[10],
            hover: palette.neutral[10],
            surface: palette.neutral[10],
            disabled: palette.neutral.zero,
            neutral: {
                base: palette.neutral.zero,
                active: palette.neutral[30],
                focus: palette.neutral[10],
                hover: palette.neutral[30],
                surface: palette.neutral[150],
                disabled: palette.neutral[10],
                fill: {
                    base: palette.neutral[45],
                    hover: palette.neutral[100],
                    active: palette.neutral[100],
                    focus: palette.neutral[30],
                    surface: palette.neutral[70],
                    disabled: palette.neutral[15]
                }
            },
            interactive: {
                base: palette.neutral.zero,
                active: palette.interactive[15],
                focus: palette.interactive[10],
                hover: palette.interactive[10],
                surface: palette.interactive[13],
                disabled: palette.neutral.zero,
                fill: {
                    base: palette.interactive[45],
                    hover: palette.interactive[70],
                    active: palette.interactive[100],
                    focus: palette.interactive[70],
                    surface: palette.interactive[15],
                    disabled: palette.interactive[45]
                }
            },
            brand: {
                base: palette.neutral.zero,
                active: palette.brand[15],
                focus: palette.brand[10],
                hover: palette.brand[10],
                surface: palette.brand[10],
                disabled: palette.neutral[15],
                fill: {
                    base: palette.brand[45],
                    hover: palette.brand[70],
                    active: palette.brand[100],
                    focus: palette.brand[30],
                    surface: palette.brand[10],
                    disabled: palette.neutral[15]
                }
            },
            accent: {
                base: palette.neutral.zero,
                active: palette.accent[15],
                focus: palette.accent[10],
                hover: palette.accent[10],
                surface: palette.accent[13],
                disabled: palette.neutral.zero,
                fill: {
                    base: palette.accent[30],
                    active: palette.accent[70],
                    focus: palette.accent[45],
                    hover: palette.accent[45],
                    surface: palette.accent[15],
                    disabled: palette.accent[30]
                }
            },
            tertiary: {
                base: palette.neutral.zero,
                active: palette.tertiary[15],
                focus: palette.tertiary[10],
                hover: palette.tertiary[10],
                surface: palette.tertiary[13],
                disabled: palette.neutral.zero,
                fill: {
                    base: palette.tertiary[45],
                    active: palette.tertiary[100],
                    focus: palette.tertiary[70],
                    hover: palette.tertiary[70],
                    surface: palette.tertiary[15],
                    disabled: palette.tertiary[45]
                }
            },
            danger: {
                base: palette.neutral.zero,
                active: palette.danger[15],
                focus: palette.danger[10],
                hover: palette.danger[10],
                surface: palette.danger[13],
                disabled: palette.neutral.zero,
                fill: {
                    base: palette.danger[45],
                    active: palette.danger[100],
                    focus: palette.danger[70],
                    hover: palette.danger[70],
                    surface: palette.danger[30],
                    disabled: palette.neutral[15]
                }
            },
            warning: {
                base: palette.neutral.zero,
                active: palette.warning[15],
                focus: palette.warning[10],
                hover: palette.warning[10],
                surface: palette.warning[10],
                disabled: palette.neutral.zero,
                fill: {
                    base: palette.warning[15],
                    active: palette.warning[45],
                    focus: palette.warning[30],
                    hover: palette.warning[30],
                    surface: palette.warning[13],
                    disabled: palette.warning[15]
                }
            },
            success: {
                base: palette.neutral.zero,
                active: palette.success[15],
                focus: palette.success[10],
                hover: palette.success[10],
                surface: palette.success[13],
                disabled: palette.neutral.zero,
                fill: {
                    base: palette.success[45],
                    active: palette.success[100],
                    focus: palette.success[70],
                    hover: palette.success[70],
                    surface: palette.success[15],
                    disabled: palette.neutral[45]
                }
            }
        },
        borderColor: {
            base: palette.neutral[45],
            soft: palette.neutral[15],
            active: palette.neutral[45],
            focus: palette.neutral[45],
            hover: palette.interactive[45],
            disabled: palette.neutral[15],
            neutral: {
                base: palette.neutral[100],
                active: palette.neutral[100],
                focus: palette.interactive[45],
                hover: palette.neutral[70],
                disabled: palette.neutral[15],
                fill: {
                    base: palette.neutral.zero,
                    active: palette.neutral.zero,
                    focus: palette.neutral.zero,
                    hover: palette.neutral.zero,
                    disabled: palette.neutral.zero,
                    surface: palette.neutral[70]
                }
            },
            interactive: {
                base: palette.interactive[45],
                active: palette.interactive[100],
                focus: palette.interactive[30],
                hover: palette.interactive[70],
                disabled: palette.neutral[15]
            },
            brand: {
                base: palette.brand[45],
                active: palette.brand[100],
                focus: palette.brand[30],
                hover: palette.brand[70],
                disabled: palette.neutral[15]
            },
            accent: {
                base: palette.accent[45],
                active: palette.accent[100],
                focus: palette.accent[30],
                hover: palette.accent[70],
                disabled: palette.neutral[15]
            },
            tertiary: {
                base: palette.tertiary[45],
                active: palette.tertiary[100],
                focus: palette.tertiary[30],
                hover: palette.tertiary[70],
                disabled: palette.neutral[15]
            },
            danger: {
                base: palette.danger[45],
                active: palette.danger[100],
                focus: palette.danger[30],
                hover: palette.danger[70],
                disabled: palette.neutral[15]
            },
            success: {
                base: palette.success[45],
                active: palette.success[100],
                focus: palette.success[30],
                hover: palette.success[70],
                disabled: palette.neutral[15]
            },
            warning: {
                base: palette.warning[15],
                active: palette.neutral.zero,
                focus: palette.warning[30],
                hover: palette.warning[10],
                disabled: palette.neutral[15]
            }
        },
        breakpoint: {
            s: 560,
            m: 800,
            l: 1080,
            xl: 1280,
            xxl: 1464
        },
        depth: {
            boxShadow: {
                soft: {
                    xOffset: '0rem',
                    yOffset: '0.5rem',
                    blurRadius: '1.25rem',
                    spreadRadius: '0rem',
                    color: 'rgba(0, 0, 0, 0.06)'
                },
                hard: {
                    xOffset: '0rem',
                    yOffset: '0.25rem',
                    blurRadius: '0.5rem',
                    spreadRadius: '-0.125rem',
                    color: 'rgba(0, 0, 0, 0.25)'
                },
                0: {
                    xOffset: '0px',
                    yOffset: '0px',
                    blurRadius: '0px',
                    spreadRadius: '0px',
                    color: 'rgba(0, 0, 0, 0.0)'
                },
                1: {
                    xOffset: '0px',
                    yOffset: '0px',
                    blurRadius: '12px',
                    spreadRadius: '2px',
                    color: 'rgba(0, 0, 0, 0.10)'
                },
                2: {
                    xOffset: '0px',
                    yOffset: '4px',
                    blurRadius: '16px',
                    spreadRadius: '-4px',
                    color: 'rgba(0, 0, 0, 0.10)'
                },
                3: {
                    xOffset: '0px',
                    yOffset: '4px',
                    blurRadius: '20px',
                    spreadRadius: '0px',
                    color: 'rgba(0, 0, 0, 0.20)'
                },
                4: {
                    xOffset: '0px',
                    yOffset: '4px',
                    blurRadius: '20px',
                    spreadRadius: '-2px',
                    color: 'rgba(0, 0, 0, 0.25)'
                }
            },
            opacity: {
                transparent: 0,
                min: 0.3,
                light: 0.4,
                medium: 0.5,
                heavy: 0.8,
                max: 0.9,
                opaque: 1
            },
            zIndex: {
                100: 100,
                400: 400,
                800: 800,
                1600: 1600
            }
        },
        icon: {
            size: {
                s: '1rem',
                m: '1.5rem',
                l: '2rem',
                xl: '2rem'
            }
        },
        size: {
            border: {
                base: 1,
                focus: 2,
                active: 4,
                disabled: 1,
                radius: {
                    none: '0px',
                    twoX: '4px',
                    threeX: '6px',
                    fiveX: '10px',
                    round: '1000px'
                }
            }
        },
        transition: {
            duration: {
                default: '.3s'
            }
        },
        font: {
            color: {
                base: palette.neutral[150],
                soft: palette.neutral[45],
                fill: palette.neutral.zero,
                active: palette.neutral[100],
                focus: palette.neutral[100],
                hover: palette.neutral[100],
                disabled: palette.neutral[30],
                onLight: palette.neutral[150],
                onDark: palette.neutral.zero,
                neutral: {
                    base: palette.neutral[45],
                    fill: palette.neutral.zero,
                    active: palette.neutral[100],
                    focus: palette.neutral[30],
                    hover: palette.neutral[70],
                    disabled: palette.neutral[30]
                },
                interactive: {
                    base: palette.interactive[45],
                    fill: palette.neutral.zero,
                    active: palette.interactive[100],
                    focus: palette.interactive[30],
                    hover: palette.interactive[70],
                    disabled: palette.neutral[30]
                },
                brand: {
                    base: palette.brand[45],
                    fill: palette.neutral.zero,
                    active: palette.brand[100],
                    focus: palette.brand[30],
                    hover: palette.brand[70],
                    disabled: palette.neutral[30]
                },
                accent: {
                    base: palette.accent[45],
                    fill: palette.neutral.zero,
                    active: palette.accent[100],
                    focus: palette.accent[30],
                    hover: palette.accent[70],
                    disabled: palette.neutral[30]
                },
                tertiary: {
                    base: palette.tertiary[45],
                    fill: palette.neutral.zero,
                    active: palette.tertiary[100],
                    focus: palette.tertiary[30],
                    hover: palette.tertiary[70],
                    disabled: palette.neutral[30]
                },
                danger: {
                    base: palette.danger[45],
                    fill: palette.neutral.zero,
                    active: palette.danger[100],
                    focus: palette.danger[30],
                    hover: palette.danger[70],
                    disabled: palette.neutral[30]
                },
                success: {
                    base: palette.success[45],
                    fill: palette.neutral.zero,
                    active: palette.success[100],
                    focus: palette.success[30],
                    hover: palette.success[70],
                    disabled: palette.neutral[30]
                },
                warning: {
                    base: palette.neutral.max,
                    fill: palette.neutral.max,
                    active: palette.neutral.max,
                    focus: palette.neutral.max,
                    hover: palette.neutral.max,
                    disabled: palette.neutral[30]
                }
            },
            lineHeight: {
                heading: '1.25',
                prose: '1.6',
                list: '1.25',
                base: '1.5'
            },
            base: {
                family: "'Rubik', 'Helvetica', 'Arial'",
                weight: {
                    light: typographyUpdates ? undefined : 300,
                    regular: 400,
                    medium: typographyUpdates ? 500 : undefined,
                    bold: typographyUpdates ? 600 : 500
                },
                size: {
                    h1: '2.25rem',
                    h2: '1.5rem',
                    h3: '1.3125rem',
                    h4: '1.125rem',
                    h5: '0.875rem',
                    h6: '0.75rem',
                    l: '1.25rem',
                    m: '1rem',
                    s: '0.875rem',
                    xs: '0.8125rem',
                    xxs: '0.75rem',
                    0: '0.625rem',
                    1: '0.75rem',
                    2: '0.8125rem',
                    3: '0.875rem',
                    4: '1rem',
                    5: '1.125rem',
                    6: '1.25rem',
                    7: '1.5rem',
                    8: typographyUpdates ? '1.75rem' : '1.875rem',
                    9: typographyUpdates ? '2rem' : '2.25rem',
                    10: typographyUpdates ? '2.25rem' : '3rem',
                    11: typographyUpdates ? '3rem' : undefined
                }
            },
            prose: {
                family: "'Open Sans', 'Rubik', 'Helvetica', 'Arial', sans-serif",
                weight: {
                    light: typographyUpdates ? undefined : 400,
                    regular: 400,
                    bold: 700
                },
                size: {
                    l: '1.25rem',
                    m: '1rem',
                    s: '0.875rem',
                    xs: '0.8125rem',
                    xxs: '0.75rem'
                }
            },
            mono: {
                family: "'Roboto Mono', monospace",
                weight: {
                    light: typographyUpdates ? undefined : 400,
                    regular: 400,
                    bold: 400
                },
                size: {
                    l: '1.25rem',
                    m: '1rem',
                    s: '0.875rem',
                    xs: '0.8125rem',
                    xxs: '0.75rem'
                }
            }
        },
        animation: {
            expressive: {
                easeOut: {
                    easing: 'cubic-bezier(0, 0, 0.39, 1)',
                    duration: {
                        fastest: '100ms',
                        fast: '200ms',
                        medium: '400ms',
                        slow: '550ms',
                        slowest: '700ms'
                    }
                },
                easeIn: {
                    easing: 'cubic-bezier(0.4, 0.14, 1, 1)',
                    duration: {
                        fastest: '100ms',
                        fast: '200ms',
                        medium: '400ms',
                        slow: '550ms',
                        slowest: '700ms'
                    }
                },
                easeInOut: {
                    easing: 'cubic-bezier(0.4, 0.15, 0.3, 1)',
                    duration: {
                        fastest: '100ms',
                        fast: '200ms',
                        medium: '400ms',
                        slow: '550ms',
                        slowest: '700ms'
                    }
                }
            },
            productive: {
                easeOut: {
                    easing: 'cubic-bezier(0, 0, 0.4, 0.9)',
                    duration: {
                        fastest: '100ms',
                        fast: '200ms',
                        medium: '400ms',
                        slow: '550ms',
                        slowest: '700ms'
                    }
                },
                easeIn: {
                    easing: 'cubic-bezier(0.2, 0, 1, 0.9)',
                    duration: {
                        fastest: '100ms',
                        fast: '200ms',
                        medium: '400ms',
                        slow: '550ms',
                        slowest: '700ms'
                    }
                },
                easeInOut: {
                    easing: 'cubic-bezier(0.2, 0, 0.4, 0.9)',
                    duration: {
                        fastest: '100ms',
                        fast: '200ms',
                        medium: '400ms',
                        slow: '550ms',
                        slowest: '700ms'
                    }
                }
            },
            linear: {
                easing: 'cubic-bezier(0,0,1,1)',
                duration: {
                    fastest: '100ms',
                    fast: '200ms',
                    medium: '400ms',
                    slow: '550ms',
                    slowest: '700ms'
                }
            },
            delay: {
                fastest: '100ms',
                fast: '200ms',
                medium: '400ms',
                slow: '550ms',
                slowest: '700ms'
            },
            transition: {
                duration: {
                    default: '.3s'
                }
            },
            transform: {
                shrink: 'scale(0.96)',
                grow: 'scale(1.04)'
            },
            duration: {
                50: '50ms',
                100: '100ms',
                200: '200ms',
                300: '300ms',
                400: '400ms',
                550: '550ms',
                700: '700ms',
                800: '800ms',
                1200: '1200ms',
                reducedMotion: '100ms'
            }
        },
        spacing: {
            1: '0.125rem',
            2: '0.25rem',
            3: '0.5rem',
            4: '0.75rem',
            5: '1rem',
            6: '1.5rem',
            7: '2rem',
            8: '2.5rem',
            9: '3rem',
            10: '4rem'
        }
    };
};
export default carinaDefaultFormula;
